import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { color, toCurrency, mapState } from '@deerplusofficial/pos-helper';
import { Calculator } from '@deerplusofficial/pos-components';
import MemberActions from '../MemberActions/MemberActions';
import Info from '../Info/Info';
import InfoSection from '../Info/InfoSection';
import InfoSectionPoints from '../Info/InfoSectionPoints';
import InfoSectionWrapper from '../Info/InfoSectionWrapper';
import { withCheckout } from '../../model/Mutations';
import TabContent from './TabContent';
import CheckoutButton from './CheckoutButton';
import { CalculatorWrapper } from './CashTab';

const CardPrice = styled.span`
  color: ${color.text.info};
`;

const CardInput = styled.span`
  font-family: 'ZCOOL QingKe HuangYou', cursive;
  color: ${color.text.info};
  letter-spacing: 0.2em;
`;

class CreditCardTab extends React.PureComponent {
  static propTypes = {
    order: PropTypes.shape(),
    meta: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    order: {},
    meta: [],
  };

  state = {
    cardNumber: '',
  };

  onChange = cardNumber => {
    if (!/^\d{0,4}$/.test(cardNumber)) return;

    this.setState({ cardNumber });
  };

  onSubmit = () => {
    const { onCheckout, meta } = this.props;
    const { cardNumber } = this.state;
    const methodId = _.get(...meta, 'id');

    onCheckout({
      cardNumber,
      methodId,
    });
  };

  render() {
    const {
      order: { price, submitting, points },
    } = this.props;
    const { cardNumber } = this.state;

    return (
      <React.Fragment>
        <TabContent>
          <InfoSectionWrapper>
            <InfoSectionPoints />
            <InfoSection>
              <Info label="刷卡金額">
                <CardPrice>{toCurrency(price - points)}</CardPrice>
              </Info>
            </InfoSection>
            <InfoSection>
              <Info label="信用卡末四碼">
                <CardInput>{cardNumber}</CardInput>
              </Info>
            </InfoSection>
            <MemberActions />
          </InfoSectionWrapper>
          <CalculatorWrapper>
            <Calculator
              large
              mode="keyboard"
              value={cardNumber}
              onChange={this.onChange}
            />
          </CalculatorWrapper>
        </TabContent>
        <CheckoutButton
          loading={submitting}
          onClick={this.onSubmit}
          disabled={_.size(cardNumber) !== 4}
        />
      </React.Fragment>
    );
  }
}

export default fp.compose(
  withCheckout(),
  connect(mapState(['order']))
)(CreditCardTab);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/CreditCardTab.js